//lib
import React, { useContext, useEffect, useState } from "react";

// js-utils
import { isEmpty, safeJsonParse } from "@swiggy-private/js-utils";

// context
import Blaze from "@swiggy-private/blaze.js";
import { BottomBarContext, ScrolledStateContext, SwiggyContextHeader } from "@swiggy-private/portal-dineout-context";

// next
import { useRouter } from "next/compat/router";

// component
import { getBridgeSdk, isApp } from "utils";
import { REDIRECTIONTYPES } from "utils/types";
import CurtainRaiser from "../../../components/CurtainRaiser/CurtainRaiser";
import Menu from "../../../components/Menu";
import { RECORD_PERCIEVED_TIME_EVENTS } from "../../../constants/menu";
import { useHardwareBackHandler } from "../../../hooks";
import { useKeyboardState } from "../../../hooks/useKeyboardState";
import QrLayout from "../../../layouts/qr";

// styled
import { Container, LandingMain } from "../../../styles/home";

// defs
import type { NextPageWithLayout } from "../../_app";

const MenuPage: NextPageWithLayout = () => {
    const router = useRouter();
    useKeyboardState();
    const { swiggyHeaders } = useContext(SwiggyContextHeader);
    const { isVisible: hasBottomBar, setIsVisible: setHasBottomBar } = useContext(BottomBarContext);
    const [curtainRaiserReady, setCurtainRaiserReady] = useState(false);
    const [showCurtainRaiser, setShowCurtainRaiser] = useState(false);
    const [isCurtainRaiserShown, setIsCurtainRaiserShown] = useState(false);

    useHardwareBackHandler(REDIRECTIONTYPES.MENU);

    useEffect(() => {
        const menuEventLoaded = safeJsonParse(
            sessionStorage?.getItem?.(RECORD_PERCIEVED_TIME_EVENTS.MENU_LOAD_EVENT) || "false",
        );
        if (menuEventLoaded) {
            return;
        }
        Blaze.recordTimeFromAppStart(RECORD_PERCIEVED_TIME_EVENTS.MENU_LOAD_EVENT);
        sessionStorage?.setItem?.(RECORD_PERCIEVED_TIME_EVENTS.MENU_LOAD_EVENT, "true");
    }, []);

    if (!router?.isReady || (isApp() && isEmpty(swiggyHeaders))) {
        return <></>;
    }

    return (
        <ScrolledStateContext.Provider
            value={{
                sdk: getBridgeSdk(),
                router,
                isApp: isApp(),
            }}
        >
            <Container hasBottomBar={hasBottomBar}>
                <LandingMain>
                    <CurtainRaiser
                        show={showCurtainRaiser}
                        setShow={setShowCurtainRaiser}
                        ready={curtainRaiserReady}
                        setReady={setCurtainRaiserReady}
                        setIsCurtainRaiserShown={setIsCurtainRaiserShown}
                        setHasBottomBar={setHasBottomBar}
                    />
                    <Menu setHasBottomBar={setHasBottomBar} isCurtainRaiserShown={isCurtainRaiserShown} />
                </LandingMain>
            </Container>
        </ScrolledStateContext.Provider>
    );
};

MenuPage.getLayout = function getLayout(page: React.ReactElement) {
    return <QrLayout>{page}</QrLayout>;
};

export default MenuPage;
